// 基础权限服务
export const MTC_AUTH = 'mtc-auth/'
// 工作流服务
export const MTC_ACTIVITI = 'mtc-activiti/'
// 在线表单服务
export const MTC_ONLINE = 'online/'